import React, {useEffect, useState, useCallback} from 'react'
import FormInputSelectAsync from "../../../../common/form/form-input-select-async";
import {fetchLocations} from "../../../../../modules/locations";

// Simple debounce utility
function debounce(fn, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  };
}

export default function LocationSelect({ className, chain_id, updateField, location }) {
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(location || {})

  useEffect(() => {
    filterLocations()
  }, [])

  function filterLocations(query) {
    fetchLocations({ chain_id, query: query, status: 'active', sort_column: 'name', sort_direction: 'asc' })
      .then((data) => {
        setLocations(data.result);
      })
  }

  const debounceSearch = useCallback(
    debounce((query) => {
      filterLocations(query);
    }, 150),
    [chain_id]
  );

  return (
    <FormInputSelectAsync
      className={className}
      options={locations}
      selected={selectedLocation}
      setSelected={(newLocation) => {
        if(!newLocation) return;
        setSelectedLocation(newLocation)
        updateField('location_id', newLocation.id);
      }}
      updateOptions={debounceSearch}
      renderDisplay={(option) => `${option.display_name} ${option.chain_number}, ${option.city}, ${option.state_code}`}
      renderOption={(option) => (
        <div className="grid grid-cols-2 w-[400px]">
          <div className="p-2">{option.display_name} {option.chain_number}</div>
          <div className="p-2">{option.city}, {option.state_code}</div>
        </div>
      )}
    />
  )
}
